export default __webpack_public_path__ + "static/media/authBackground.08cd94bd.webp";